<template>

  <div class="vflex">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Billing') }}</h4>
        </div>
        <div class="btn-row">
        </div>
      </div>
    </div>
    <creating
      v-if="creating"
      height="100%" />
    <div
      v-if="!creating"
      class="vflex-row-1">
      <div
        v-if="!accessDenied"
        class="height-100">
        <router-view></router-view>
      </div>
      <div
        v-if="accessDenied"
        class="p-3">
        Você não possui permissão para acessar o módulo de cobrança.<br>
        Para obter assistência ou mais informações, entre em contato com o administrador da sua conta.
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Billing',
  components: {
  },
  data () {
    return {
      creating: true,
      accessDenied: false
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    hasSubscription () {
      return this.billingResume.subscription && this.billingResume.subscription.operating_or_pending
    }
  },
  watch: {
    // Observa mudanças na rota
    $route (to, from) {
      if (!this.hasSubscription && to.name !== 'billing.steps') {
        this.$router.push('/billing/steps/plans')
      }
    }
  },
  created () {
    this.$store.dispatch('selectBillingResume').then(() => {
      this.creating = false

      if (!this.hasSubscription) {
        this.$router.push('/billing/steps/plans')
      }
    }).catch(err => {
      if (err.response.status === 403) {
        this.creating = false
        this.accessDenied = true
      }
    })
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/Billing.vue